import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { LOGO_URL } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("otelpro_admin_token", r.data.token);
      toast.success("Giriş başarılı");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy p-4" data-testid="admin-login-page">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl overflow-hidden">
        <div className="bg-navy text-white py-8 px-7 text-center">
          <div className="h-14 w-14 mx-auto rounded-md bg-white/5 border border-white/10 p-2 flex items-center justify-center mb-3">
            <img src={LOGO_URL} alt="Otel Pro" className="h-full w-auto" />
          </div>
          <h1 className="heading-serif text-xl font-semibold">Otel Pro Yönetim Paneli</h1>
          <p className="text-white/60 text-xs mt-1">Lütfen kimlik bilgilerinizle giriş yapın</p>
        </div>
        <form onSubmit={submit} className="p-7 space-y-4">
          <div>
            <Label className="text-xs">E-posta</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
          </div>
          <div>
            <Label className="text-xs">Şifre</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-gold hover:bg-[#c49d58]" data-testid="admin-login-submit">
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </Button>
        </form>
      </div>
    </div>
  );
}
